<template>
  <PModal
    title=""
    :model-value="show"
    @update:model-value="onModalChange"
    class="relative"
    size="xl"
    data-sentry-id="OnboardingModal"
  >
    <OnboardingContent />
  </PModal>
</template>

<script setup lang="ts">
import { PModal } from "@pasta/box-v2";
import { computed } from "vue";
import { useUserPreferencesStore } from "../../stores/user-preferences.store.ts";
import OnboardingContent from "./OnboardingContent.vue";

const userPreferencesStore = useUserPreferencesStore();

async function onModalChange(opening: boolean) {
  if (!opening) {
    await end();
  }
}

const show = computed(() => !userPreferencesStore.onboardingSeen);

async function end() {
  await userPreferencesStore.updateMine({ onboardingSeen: true });
}
</script>
